import { render, staticRenderFns } from "./playClassList.vue?vue&type=template&id=5dde4965&scoped=true&"
import script from "./playClassList.vue?vue&type=script&lang=ts&"
export * from "./playClassList.vue?vue&type=script&lang=ts&"
import style0 from "./playClassList.vue?vue&type=style&index=0&id=5dde4965&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde4965",
  null
  
)

export default component.exports